import React, { useState } from "react";
import { FaWhatsapp, FaEnvelope, FaPhone, FaHeadset} from "react-icons/fa";
import "../styles/FloatingContactButton.css"; // Import custom CSS

const FloatingContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`floating-contact ${isOpen ? "open" : ""}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {/* Main Button */}
      <div className="contact-main">
        <FaHeadset size={24} />
      </div>

      {/* Contact Items (Visible on Hover) */}
      <a href="https://wa.me/9045502946" target="_blank" rel="noopener noreferrer" className="contact-item whatsapp">
        <FaWhatsapp size={24} />
      </a>

      <a href="mailto:shyampalace6811@gmail.com" className="contact-item email">
        <FaEnvelope size={24} />
      </a>

      <a href="tel:+919045502946" className="contact-item phone">
        <FaPhone size={24} />
      </a>
    </div>
  );
};

export default FloatingContactButton;
